module.exports = __webpack_public_path__ + "img/soft_7.972c23d3.png";